import DeleteLeft from './DeleteLeft';

export default DeleteLeft;
